// Mobile menu: built from the desktop nav so links stay in one place.
(function () {
  document.querySelectorAll('header').forEach(function (header) {
    var toggle = header.querySelector('.nav-toggle');
    var desktop = header.querySelector('.nav-desktop');
    if (!toggle || !desktop) return;
    var nav = document.createElement('nav');
    nav.className = 'mobile-nav';
    nav.id = 'mobile-nav';
    nav.setAttribute('aria-label', 'Mobile');
    nav.hidden = true;
    var links = desktop.querySelectorAll('a');
    links.forEach(function (a, i) {
      var m = document.createElement('a');
      m.href = a.getAttribute('href');
      m.textContent = i === links.length - 1 ? 'Score your idea free' : a.textContent;
      if (i === links.length - 1) m.className = 'mobile-cta';
      if (a.getAttribute('aria-current')) m.setAttribute('aria-current', 'page');
      nav.appendChild(m);
    });
    header.appendChild(nav);
    toggle.setAttribute('aria-controls', 'mobile-nav');
    toggle.addEventListener('click', function () {
      var open = nav.hidden;
      nav.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
  });
})();
